const TRANSLATION = {
  common: {
    loading: 'Загрузка',
  },
  i18n: {
    English: 'Английский',
    Spanish: 'Испанский',
    Russian: 'Русский',
    'Portuguese (Brazil)': 'Португальский (Бразилия)',
    Indonesian: 'Индонезийский',
    Czech: 'Чешский',
    German: 'Немецкий',
    French: 'Французский',
    Italian: 'Итальянский',
    Dutch: 'Голландский',
    Polish: 'Польский',
    Vietnamese: 'Вьетнамский',
    Turkish: 'Турецкий',
    Ukrainian: 'Украинский',
    Chinese: 'Упрощенный китайский',
    'Traditional Chinese': 'Традиционный китайский',
    Japanese: 'Японский',
    Korean: 'Корейский',
    Arabic: 'Арабский',
    Persian: 'Персидский',
    Thai: 'Тайский',
    Hindi: 'Хинди',
    Malay: 'Малайский',
    province: {
      Hebei: 'Провинция Хэбэй',
      Shanxi: 'Провинция Шаньси',
      Liaoning: 'Провинция Ляонин',
      Jilin: 'Провинция Цзилинь',
      Heilongjiang: 'Провинция Хэйлунцзян',
      Jiangsu: 'Провинция Цзянсу',
      Zhejiang: 'Провинция Чжэцзян',
      Anhui: 'Провинция Аньхой',
      Fujian: 'Провинция Фуцзянь',
      Jiangxi: 'Провинция Цзянси',
      Shandong: 'Провинция Шаньдун',
      Henan: 'Провинция Хэнань',
      Hubei: 'Провинция Хубэй',
      Hunan: 'Провинция Хунань',
      Guangdong: 'Провинция Гуандун',
      Hainan: 'Провинция Хайнань',
      Sichuan: 'Провинция Сычуань',
      Guizhou: 'Провинция Гуйчжоу',
      Yunan: 'Провинция Юньнань',
      Shaanxi: 'Провинция Шэньси',
      Gansu: 'Провинция Ганьсу',
      Qinghai: 'Провинция Цинхай',
      Taiwan: 'Провинция Тайвань',
      Guangxi: 'Гуанси-Чжуанский автономный район',
      Neimenggu: 'Автономный район Внутренняя Монголия',
      Tibet: 'Тибетский автономный район',
      Ningxia: 'Нинся-Хуэйский автономный район',
      Xinjiang: 'Синьцзян-Уйгурский автономный район',
      HongKong: 'Специальный административный район Сянган (Гонконг)',
      Macau: 'Специальный административный район Аомэнь (Макао)',
      Beijing: 'Муниципалитет Пекин',
      Tianjin: 'Муниципалитет Тяньцзинь',
      Shanghai: 'Муниципалитет Шанхай',
      Chongqing: 'Муниципалитет Чунцин',
    },
  },
  pageHeader: {
    product: 'Продукт',
    tvcTest: 'Тестирование TVC-опыта',
    tvcEval: 'Оценка креативности TVC',
    contactUs: 'Связаться с нами',
    Pricing: 'Цены',
    Dashboard: 'Начать сейчас',
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    resourceCenter: 'Блог',
    all: 'Все',
    news: 'Новости',
    insight: 'Анализ',
    case: 'Кейсы',
  },
  productSwitch: {
    common: {
      comingSoon: 'Скоро',
    },
    modal: {
      heroTitle: 'Пожалуйста, выберите тест, который хотите запустить',
      heroSubtitle:
        'AdEff всегда готов предоставить вам многомерные креативные инсайты, когда это необходимо.',
      remainingTimes: 'Осталось запусков: {{count}}',
      supportedAssets: 'Поддерживаемые материалы',
      coreMetrics: 'Ключевые метрики',
      cognitiveNeuroscienceIndicators: 'Когнитивно-нейронные индикаторы',
      consumerAttitudeIndicators: 'Показатели отношения потребителей',
      outputResult: 'Результат вывода',
      dataReport: 'Отчет с данными',
      analysisReport: 'Аналитический отчет',
      accessBackend: 'Начать сейчас',
      tabs: {
        tvc: 'Тест горизонтального креатива',
        portrait: 'Тест вертикального креатива',
      },
      cards: {
        tvcQuick: {
          title: 'Горизонтальный-быстрый тест',
          descriptionHighlight:
            'Быстро оценивайте креативы, чтобы принимать решения на основе данных',
        },
        tvcBase: {
          title: 'Диагностика горизонтального-креатива',
          descriptionHighlight:
            'Точечно доработайте креативные детали с практическими рекомендациями по изменению.',
          value1: 'Креативы TVC/OTV длительностью 10–60 секунд',
          value2: 'Когнитивно-нейронные индикаторы',
        },
        tvcSurvey: {
          title: 'Горизонтальный-InsightPro',
          descriptionHighlight:
            'Многомерный анализ креатива со стратегическими рекомендациями по оптимизации.',
          value1: 'Креативы TVC/OTV длительностью 10–60 секунд',
          value2: 'Когнитивно-нейронные индикаторы',
        },
        portraitQuick: {
          title: 'Вертикальный-быстрый тест',
          descriptionHighlight:
            'Быстро оценивайте креативы, чтобы принимать решения на основе данных',
        },
        portraitBase: {
          title: 'Диагностика вертикального-креатива',
          descriptionHighlight:
            'Точечно доработайте креативные детали с практическими рекомендациями по изменению.',
          value1: 'Вертикальные креативы длительностью 5–90 секунд',
          value2: 'Когнитивно-нейронные индикаторы',
        },
        portraitSurvey: {
          title: 'Глубокий анализ вертикального-креатива',
          descriptionHighlight:
            'Многомерный анализ креатива со стратегическими рекомендациями по оптимизации.',
          value1: 'Вертикальные креативы длительностью 5–90 секунд',
          value2: 'Когнитивно-нейронные индикаторы',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Тест горизонтального креатива',
          assetText: 'Для TVC/OTV-креативов длительностью 10-60 сек.',
        },
        portrait: {
          bannerTitle: 'Тест вертикального креатива',
          assetText: 'Для вертикальных креативов длительностью 5-90 сек.',
        },
      },
      items: {
        tvcQuick: {
          description: 'Быстро сравнивайте креативы и принимайте решения',
        },
        tvcBase: {
          title: 'Диагностика креатива',
          description: 'Посекундная оптимизация для оттачивания креатива',
        },
        tvcSurvey: {
          title: 'Глубокий анализ',
          description: 'Комплексный анализ для точного выявления проблем',
        },
        portraitBase: {
          title: 'Диагностика креатива',
          description: 'Посекундная оптимизация для оттачивания креатива',
        },
        portraitQuick: {
          description: 'Быстро сравнивайте креативы и принимайте решения',
        },
        portraitSurvey: {
          title: 'Глубокий анализ',
          description: 'Комплексный анализ для точного выявления проблем',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Мы используем файлы cookie',
    desc: 'Мы используем необходимые файлы cookie, чтобы обеспечить нормальную работу нашего сайта. С вашего согласия мы также используем аналитические файлы cookie для улучшения вашего пользовательского опыта. Ознакомьтесь с нашей политикой использования файлов cookie в нашей политике конфиденциальности.',
    btn1: 'Отклонить все',
    btn2: 'Принять все',
    cookiePolicy: 'Политика использования файлов cookie',
  },
  landing: {
    banner: {
      text1: 'AI-управляемый',
      text2: 'Реклама',
      text3: 'Тестирование',
      text4: 'Платформа для тестирования и оптимизации креативов',
      feature1: 'Декодирование контента',
      feature2: 'Прогнозирование отзывов',
      feature3: 'Интеграция данных',
      feature4: 'Выводы и рекомендации',
      btn1: 'Получить демонстрацию',
      btn2: 'Создать проект',
    },
    info: {
      title:
        'На основе многомодальной большой языковой модели (HMLLM)* быстро реализуйте прогнозирование эффективности креативов и увеличьте возврат инвестиций в рекламу',
      subTitle:
        '*Эта модель основана на большом количестве нейропсихологических тестов и многомодальных агентных конструкций',
      detail1: 'Быстрое тестирование рекламы',
      detail1Desc:
        'AdEff может получить кривую внимания целевой аудитории, эмоциональные колебания и вовлеченность в креативный контент за 15 минут и предоставить подробный отчет и рекомендации по оптимизации.',
      detail2: 'Быстрый отбор лучших креативов',
      detail2Desc:
        'AdEff поддерживает одновременное измерение нескольких креативов, помогая брендам принимать быстрые решения. И предоставляет подробный сравнительный анализ.',
      detail3: 'Однокнопочное редактирование, создание разнообразных эффективных версий',
      detail3Desc:
        'AdEff поддерживает однокнопочное редактирование, быстро создавая разнообразные эффективные версии, подходящие для различных сценариев распространения.',
    },
    advantages: {
      title: 'Преимущества AdEff',
      item1Title: 'Быстрая реакция',
      item1Desc: 'Самый быстрый отчет за <tmp>15 минут</tmp>.',
      item2Title: 'Уникальная AI модель',
      item2Desc: 'Уникальная <tmp>AI модель</tmp>, основанная на отзывах аудитории.',
      item3Title: 'Визуальные графики',
      item3Desc:
        '<tmp>Визуальные графики</tmp> + AI интерпретация, отчет о тестировании с одним нажатием кнопки',
      item4Title: 'Огромный объем данных',
      item4Desc: '<tmp>50,000+</tmp> база креативов',
      item5Title: 'Команда экспертов',
      item5Desc: '<tmp>Команда экспертов</tmp> предоставляет поддержку и рекомендации',
    },
    service: {
      title: 'Способы обслуживания AdEff',
      desc: 'Выберите необходимый способ обслуживания',
      topTitle: 'Онлайн самообслуживание',
      topRow1: 'Самостоятельное создание проекта и завершение тестирования',
      topRow2: 'Визуальные графики + AI интерпретация отчета',
      topRow3: 'Объективный анализ нейропсихологических показателей (глазные движения + ЭЭГ)',
      topRow4: 'Уникальное тестирование AI модели',
      bottomTitle: 'Услуги команды экспертов',
      bottomRow1: 'Экспертное создание проекта и завершение тестирования',
      bottomRow2:
        'Объективный анализ нейропсихологических показателей (глазные движения + ЭЭГ), с возможностью добавления субъективных показателей',
      bottomRow3: 'Визуальные графики + экспертная интерпретация отчета',
      bottomRow4:
        'Уникальное тестирование AI модели, с возможностью тестирования реальными образцами',
    },
    footer: {
      title:
        'AdEff основан на многомодальной большой языковой модели (HMLLM), строя сложные связи между визуальными элементами EEG сигналов и данными отслеживания глаз для быстрого тестирования рекламных креативов',
      email: 'Электронная почта',
      belongDesc: 'Продукт <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Начать сейчас',
  },
  contact: {
    title: 'Связаться с нами',
    copy: 'Копировать',
    message: { success: 'Копирование успешно' },
  },
  pricing: {
    title: 'Эксперт по тестированию и оптимизации креативов на основе ИИ',
    starter: {
      title: 'Стартовый',
      desc_1: 'Подходит для одноразовых тестов, готов к использованию сразу после покупки',
      desc_2: 'Подходит для небольших тестов, готов к использованию сразу после покупки',
      timesDesc: '<strong>{{count}}</strong> раз тестирование',
      timesDesc1: '<strong>{{count}}</strong> раз тестирование',
      discount: 'Скидка 50%',
      originPrice: 'Цена',
      desc2: 'База данных на основе отзывов аудитории HMLLM',
      desc3: 'Быстрый отчет, самый быстрый отчет за 15 минут',
      desc4: 'Визуальные графики',
      desc5: 'Экспертная интерпретация',
      desc6: 'Глобальная база данных и базовые линии',
      cardDesc1: 'Ограниченная скидка, всего {{pricePerTest}}',
      cardDesc2: 'Квота тестов не сгорает',
    },
    premium: {
      time: 'раз',
    },
    unlimited: {
      title: 'Безграничный',
      cardDesc1: 'От {{pricePerTest}}',
      cardDesc2: 'Квота действует один год',
      cardDesc3: 'Индивидуальный проприетарный бенчмарк',
      planDesc500: 'Получите 500 тестов на весь год',
      planDesc1000: 'Получите 1 000 тестов на весь год',
    },
    benefits: {
      title: 'Почему выбирают AdEff?',
      subtitle: 'С AdEff вы получаете следующие преимущества:',
      expertSupport: 'Поддержка и сопровождение от команды экспертов',
      moreNeedsTitle: 'Есть другие потребности по покупке?',
      customPlanPrefix: 'Мы поддерживаем гибкие и индивидуальные тарифы — свяжитесь с нами по',
      customPlanSuffix: 'для вашего эксклюзивного решения',
    },
    subscribeBtn: 'Подписаться сейчас',
    contactUs: 'Свяжитесь с нами',
  },
  login: {
    loginText: 'Войти',
    signUpText: '<tmp>Зарегистрироваться</tmp> бесплатно',
    text1: 'Присоединитесь к команде',
    text1Desc:
      'AdEff строит гиперграфы на основе HMLLM для быстрого тестирования рекламных креативов',
    text2: 'Пользователь присоединился к компании',
    text3: 'Приглашение в команду истекло',
    text4: 'Ссылка на приглашение в команду больше не действительна.',
    optionText1: 'Уже есть учетная запись?',
    optionText2: 'Нет учетной записи?',
    alertText1: 'Регистрируясь, я согласен с',
    alertText2: 'Я согласен с',
    termsOfService: 'Условиями обслуживания',
    privacy: 'Политикой конфиденциальности',
    privacyTips: 'Пожалуйста, отметьте поле соглашения перед регистрацией.',
    and: 'и',
    or: 'или',
    next: 'Далее',
    googleLogin: 'Войти с Google',
    googleSignUp: 'Зарегистрироваться с Google',
    loginWithEmail: 'Войти с электронной почтой',
    signUpWithEmail: 'Зарегистрироваться с электронной почтой',
    password: 'Пароль',
    emailAddress: 'Электронная почта',
    enterEmail: 'Введите ваш адрес электронной почты',
    enterPassword: 'Введите ваш пароль',
    confirmPassword: 'Подтвердите пароль',
    forgotPassword: 'Забыли пароль?',
    inconsistentPassword: 'Пароли не совпадают',
    verificationCode: 'Код подтверждения',
    emptyVerificationCode: 'Код подтверждения не может быть пустым',
    enterVerificationCode: 'Введите код подтверждения',
    sendedVerificationCode: 'Код подтверждения отправлен на вашу электронную почту',
    emailOrPasswordNotCorrect: 'Электронная почта или пароль неверны.',
    message: {
      text1: 'Недопустимый ввод',
      text2: 'Электронная почта уже зарегистрирована',
      text3: 'Ошибка проверки кода подтверждения!',
      text4: 'Эта учетная запись не связана с компанией, пожалуйста, свяжитесь снова!',
      text5: 'Пожалуйста, введите правильный формат электронной почты',
      text6: 'Пароль должен содержать не менее 12 символов',
      text7: 'Пароль должен содержать uppercase letters, lowercase letters and numbers',
      requestLimit: 'Запрос превышен, пожалуйста, попробуйте позже',
    },
  },
  resetPwdPage: {
    submit: 'Отправить',
    emailNotFound: 'Пожалуйста, проверьте вашу электронную почту',
    emailHasSent: 'Электронная почта отправлена на {{email}}',
    checkYourInbox: 'Проверьте свою электронную почту',
    resetYourPassword: 'Сбросить пароль',
    resetLinkHasSent:
      'Ссылка для сброса пароля отправлена на электронную почту, связанную с вашим аккаунтом',
    enterYourEmailAddress: 'Введите ваш адрес электронной почты',
    didNotGetEmail: 'Не получили электронное письмо?',
    tryAgain: 'Попробовать снова',
    goBackToSign: 'Вернуться к входу',
    email: 'Электронная почта',
    enterYourEmail: 'Введите ваш адрес электронной почты',
    resetPassword: 'Сбросить пароль',
    resetPwdSuccess: 'Пароль успешно сброшен',
    message: {
      resetLinkCodeError: 'Ссылка для сброса пароля недействительна',
      requestLimit: 'Запрос превышен, пожалуйста, попробуйте позже',
    },
  },
  memberRequestPage: {
    title: 'Подтверждение запроса участника',
    subTitle: 'Запрос от:',
    deny: 'Отклонить',
    approve: 'Одобрить',
    teamFull: 'Команда полна',
    yourTeamIsFull:
      'Ваша команда полна. Вы можете связаться с нами для получения дополнительных участников или удалить других участников.',
    manageMembers: 'Управление участниками в AdEff',
    requestApproved: 'Запрос одобрен',
    approvedDesc:
      'Вы одобрили <tmp>{{name}}</tmp> присоединиться к вашей команде, уведомление было автоматически отправлено по электронной почте.',
    requestDeclined: 'Запрос отклонен',
    declinedDesc:
      'Вы отклонили <tmp>{{name}}</tmp> присоединиться к вашей команде, уведомление было автоматически отправлено по электронной почте.',
  },
  infoBindPage: {
    title: 'AI-управляемое тестирование рекламы',
    desc: 'На основе многомодальной большой языковой модели (HMLLM)* быстро реализуйте прогнозирование эффективности креативов и увеличьте возврат инвестиций в рекламу',
    joinAdEff: 'Присоединяйтесь к AdEff и начните новое путешествие',
    advantages: {
      title1: 'Более мощный',
      desc1: 'Уникальная AI модель на основе обширной базы данных',
      title2: 'Более экономичный',
      desc2: 'Всего 10% от традиционных цен',
      title3: 'Более быстрый',
      desc3: 'Самый быстрый отчет за 15 минут',
      title4: 'Более профессиональный',
      desc4: 'Круглосуточная поддержка и услуги команды экспертов',
    },
    username: 'Имя пользователя',
    company: 'Компания',
    placeOfResidence: 'Страна/Регион',
    invitationCode: 'Реферальный код',
    createAccountForFree: 'Создайте учетную запись бесплатно',
    refreshStatus: 'Обновить статус',
    reapply: 'Повторно подать заявку',
    bySigningUp: 'Регистрируясь, вы соглашаетесь с',
    termsOfService: 'Условиями обслуживания',
    and: 'и',
    privacyPolicy: 'Политикой конфиденциальности',
    message: {
      success: 'Запрос на создание учетной записи отправлен, пожалуйста, подождите!',
      success2: 'Учетная запись успешно создана',
      error: 'Не удалось создать учетную запись, пожалуйста, попробуйте позже.',
      accountCreatedDirectly: 'Ваша учетная запись была создана напрямую!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Запрос был одобрен, страница будет автоматически перенаправлена.',
      theRequestHasBeenSendAndPleaseBePatient: 'Запрос отправлен, пожалуйста, подождите!',
      wrongRouting: 'Ошибка маршрутизации, страница будет автоматически перенаправлена.',
      yourRequestHasBeenDeclined:
        'Ваш запрос был отклонен. Вы можете повторно подать заявку на присоединение к команде или создать новую учетную запись без пригласительного кода.',
      waitingForAdministratorReview: 'Ожидание проверки администратора',
      thisFieldIsRequired: 'Это поле обязательно для заполнения',
      pleaseEnterTheResidence: 'Пожалуйста, введите страну',
      invitationCodeDoesNotExist: 'Недействительный реферальный код',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Если вы используете это через реферальную программу агента, пожалуйста, введите реферальный код',
      pleaseEnterTheUsername: 'Пожалуйста, введите имя пользователя',
      pleaseEnterTheCompanyName: 'Пожалуйста, введите название компании',
      needRegisterAgain: 'Ошибка в операции, пожалуйста, зарегистрируйтесь снова',
      alreadyBind: 'Вы уже связали компанию, пожалуйста, не связывайтесь снова',
    },
  },
  knowledgeFormPage: {
    name: 'Ваше имя',
    email: 'Ваша электронная почта',
    companyName: 'Название компании',
    department: 'Отдел',
    role: 'Должность',
    country: 'Страна',
    province: 'Регион/область',
    pleaseEnter: 'Пожалуйста, введите',
    pleaseSelect: 'Пожалуйста, выберите',
    pleaseEnterTheName: 'Пожалуйста, введите ваше имя',
    pleaseEnterTheEmail: 'Пожалуйста, введите вашу электронную почту',
    pleaseEnterValidEmail: 'Пожалуйста, введите корректный адрес электронной почты',
    pleaseEnterTheCompanyName: 'Пожалуйста, введите название вашей компании',
    pleaseSelectTheDepartment: 'Пожалуйста, выберите отдел',
    pleaseSelectTheRole: 'Пожалуйста, выберите должность',
    pleaseSelectTheCountry: 'Пожалуйста, выберите страну',
    pleaseSelectTheProvince: 'Пожалуйста, выберите регион/область',
    textIsRequired: 'Это поле обязательно для заполнения',
    submit: 'Отправить',
    download: 'Скачать',
    submitSuccess: 'Отправлено успешно',
    downloadSuccess: 'Скачано успешно',
    title1: 'Пожалуйста, заполните свои данные для получения ресурса',
    title2: 'Пожалуйста, выберите ресурс, который хотите скачать',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Скачать отчет',
      downloadBtnText: 'Скачать PDF',
      content: 'Контент',
      theEnd: 'Конец',
      thankYouForWatching: 'Спасибо за просмотр.',
      pdfProcessing: 'Обработка PDF...',
      pdfProcessingDesc:
        'PDF страниц: {{count}}，ожидается {{seconds}} секунд, сохраните после, пожалуйста, подождите',
      pdfProcessingDesc2: 'Текущая версия языка не переведена, не может генерировать PDF',
    },
    ppt: {
      downloadBtnText: 'Скачать PPT',
      pptProcessingDesc: 'Файл PPT создается, пожалуйста, подождите',
      pptProcessingDesc2: 'Текущая языковая версия не переведена, невозможно создать PPT',
      pptProcessingDesc3: 'Идет загрузка файла PPT, пожалуйста, подождите...',
      translateCompleted: 'Перевод PPT завершен',
      exportSuccess: 'Файл PPT успешно экспортирован',
      exportFailed: 'Не удалось экспортировать файл PPT',
    },
    layout: {
      projectMenuText: 'Проекты тестирования рекламы',
      accountManagementText: 'Управление учетной записью',
      myAccountText: 'Моя учетная запись',
      subscriptionText: 'Подписка',
      logout: 'Выйти',
      dataDetails: 'Детали данных',
      dataAnalysis: 'Анализ данных',
      dataOverview: 'Обзор данных',
      dataComparison: 'Сравнение данных',
    },
    systemMessage: {
      title: 'Системное сообщение',
      task: 'Задача',
      system: 'Система',
      noRelevantContent: 'Не найдено соответствующего контента',
      noMore: 'Больше нет сообщений',
    },
    projectPage: {
      createProject: 'Создать проект',
      searchPlaceholder: 'Введите название проекта/рекламы/бренда для поиска',
      sortLabel: 'Сортировка по индексу эффективности рекламы',
      sortPlaceholder: 'Выберите метод сортировки',
      sortOption1: 'По возрастанию индекса эффективности',
      sortOption2: 'По убыванию индекса эффективности',
      filterSort: 'Фильтр и сортировка',
      filterBenchmarkTitle: 'Фильтр по бенчмарку',
      sortTitle: 'Сортировка',
      tabAllCreative: 'Все креативы ({{count}})',
      tabGeneralCreative: 'Обычные креативы ({{count}})',
      tabSplashCreative: 'Splash-креативы ({{count}})',
      generalCreativeLabel: 'Обычный креатив',
      splashCreativeLabel: 'Splash-креатив',
      normTypePlaceholder: 'Пожалуйста, выберите тип норматива',
      totalDesc: 'Рекламные проекты (всего {{total}})',
      noRelevantContent: 'Не найдено соответствующего контента',
      loadMore: 'Загрузить еще',
      projectCard: { delete: 'Удалить', reanalyze: 'Переанализировать', download: 'Скачать' },
      delete: 'Удалить',
      cancel: 'Отмена',
      message: {
        deleteTitle: 'Предупреждение об удалении',
        delete:
          'После удаления этого проекта все связанные данные станут недоступными. Вы уверены, что хотите продолжить удаление?',
        delete1:
          'Этот проект является бесплатным тестовым проектом, и его удаление не вернет возможность тестирования',
        delete2:
          'Этот проект еще не начал анализ. После удаления ваши тестовые кредиты будут возвращены',
        deleteSuccess: 'Удаление успешно!',
        analysisCountNotEnough: 'Анализ невозможен, пожалуйста, пополните счет.',
        analysisFailed: 'Анализ невозможен, пожалуйста, попробуйте снова.',
        waitingQuestion:
          'Максимум 3 проекта могут анализироваться одновременно. Этот проект добавлен в очередь ожидания и анализ начнется автоматически позже.',
        landscapeQuickCompleted: 'Ваш горизонтальный проект быстрого тестирования завершен.',
        portraitQuickCompleted: 'Ваш вертикальный проект быстрого тестирования завершен.',
        landscapeSurveyCompleted: 'Ваш горизонтальный проект глубокого анализа завершен.',
        portraitSurveyCompleted: 'Ваш вертикальный проект глубокого анализа завершен.',
      },
    },
    projectCreatePage: {
      createProject: 'Создать проект',
      basicInformation: 'Основная информация',
      projectType: 'Тип проекта',
      projectName: 'Название проекта',
      categoryType: 'Отрасль',
      brandName: 'Название бренда',
      advertisingInformation: 'Информация о рекламе',
      adName: 'Название рекламы',
      norm: 'Базовый показатель',
      targetMarketNorm: 'Базовый показатель целевого рынка',
      brandNorm: 'Базовый показатель бренда',
      taGender: 'Пол целевой аудитории',
      targetMarket: 'Целевой рынок',
      taAge: 'Возраст целевой аудитории',
      next: 'Далее',
      previous: 'Назад',
      confirmOrder: 'Подтвердить заказ',
      estTime: 'Ожидаемое время',
      minutes: 'минуты',
      consumption: 'Расходы по этому заказу',
      testPoint: 'Количество тестов',
      remaining: 'Осталось',
      times: 'раз',
      type: 'Тип',
      purchase: 'Покупка',
      outputLanguage: 'Язык вывода',
      durationCategory: 'Тип креатива',
      durationCategoryDesc: 'Показатели анализа зависят от типа креатива. Выберите вариант, который лучше всего соответствует вашему контенту.',
      durationCategoryOptions: {
        tenPlus: 'Обычный креатив (10с+)',
        fiveToTen: 'Открывающий креатив (5-10с)',
      },
      adSelection: {
        adCreativeTest: 'Тестирование креативов рекламы',
        adCreativeTestDesc:
          'Тестирование отзывов целевой аудитории на один рекламный креатив, предоставление анализа и рекомендаций',
        adCreativeSelection: 'Отбор креативов рекламы',
        adCreativeSelectionDesc:
          'Сравнение отзывов на несколько рекламных креативов, комплексный выбор',
        adCreativeEditing: 'Редактирование креативов рекламы',
        adCreativeEditingDesc:
          'AI умное выделение лучших частей рекламного креатива, автоматическое создание рекламного креатива',
        launchingSoon: 'Скоро в запуске',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Продукты питания и напитки',
        packagedFood: 'Упакованные продукты',
        confectionery: 'Кондитерские изделия',
        frozenMeals: 'Замороженные блюда',
        fastFood: 'Фастфуд',
        beverage: 'Напитки',
        alcohol: 'Алкоголь',
        dairy: 'Молочные продукты',
        grainAndSeasoning: 'Мука и специи',
        beverageMixes: 'Напитки',
        freshProduce: 'Свежие продукты',
        otherFoodAndBeverage: 'Другие продукты питания и напитки',
        /**----------------------- */
        consumerElectronicsCategory: 'Электроника для потребителей',
        mobilePhone: 'Мобильные телефоны',
        computer: 'Компьютеры',
        smartDevice: 'Умное устройство',
        phoneAccessories: 'Аксессуары для телефонов',
        computerAccessories: 'Аксессуары для компьютеров',
        software: 'Программное обеспечение',
        camera: 'Фотоаппараты',
        officeSupplies: 'Офисные принадлежности',
        otherConsumerElectronics: 'Другие электронные устройства',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Фармацевтика и здравоохранение',
        otcMedicine: 'Нерецептурные лекарства',
        prescriptionDrugs: 'Рецептурные лекарства',
        healthSupplements: 'Здоровье и питание',
        pharmaceuticalCompanies: 'Фармацевтические компании',
        medicalDevices: 'Медицинские устройства',
        medicalServices: 'Медицинские услуги',
        pharmacy: 'Аптеки',
        otherPharmaceuticalsAndHealthCare: 'Другие фармацевтические и медицинские услуги',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Красота и уход за собой',
        hairCare: 'Уход за волосами',
        womenSkincare: 'Уход за кожей лица',
        homeCleaning: 'Уборка дома',
        bodyCare: 'Уход за телом',
        feminineCare: 'Уход за женскими органами',
        oralCare: 'Уход за полостью рта',
        menSkincare: 'Уход за мужскими органами',
        makeup: 'Макияж',
        fragrances: 'Парфюмы',
        beautyServices: 'Красочные услуги',
        otherBeautyAndPersonalCare: 'Другие красочные услуги',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Младенчество и уход за детьми',
        babyFood: 'Детское питание',
        babyCareEssentials: 'Детские необходимые продукты',
        babyToys: 'Детские игрушки',
        otherMaternalAndInfantProducts: 'Другие продукты для младенцев',
        /**----------------------- */
        networkAndCommunicationCategory: 'Сети и связь',
        mobileCarriers: 'Мобильные операторы',
        internetProviders: 'Интернет-провайдеры',
        telecomEquipment: 'Телекоммуникационное оборудование',
        otherNetworkAndCommunication: 'Другие сети и связь',
        /**----------------------- */
        travelAndAccommodationCategory: 'Путешествия и размещение',
        localTourism: 'Локальные туры',
        bookingPlatform: 'Платформа бронирования',
        hotels: 'Отели',
        airlines: 'Авиакомпании',
        airport: 'Аэропорты',
        otherTravelAndAccommodation: 'Другие путешествия и размещение',
        /**----------------------- */
        vehiclesCategory: 'Транспортные средства',
        motorVehicleProductsAndServices: 'Моторные транспортные средства и услуги',
        carBrands: 'Бренды автомобилей',
        dealerships: 'Диллеры',
        carFinance: 'Автокредиты',
        evCar: 'Электромобили',
        motorcycle: 'Мотоциклы',
        onlineUsedCarMarketplace: 'Онлайн-площадка для покупки и продажи подержанных автомобилей',
        carRentalPlatform: 'Платформа для аренды автомобилей',
        travelNavigation: 'Навигация по путешествиям',
        bicycle: 'Велосипеды',
        otherVehicles: 'Другие транспортные средства',
        /**----------------------- */
        householdAppliancesCategory: 'Бытовая техника',
        majorAppliances: 'Бытовая техника',
        healthAndPersonalCareAppliances: 'Бытовая техника1',
        majorKitchenAndBathAppliances: 'Бытовая техника2',
        smallKitchenAppliances: 'Бытовая техника3',
        environmentalAppliances: 'Бытовая техника4',
        cleaningAppliances: 'Бытовая техника5',
        otherHouseholdAppliances: 'Бытовая техника6',
        /**----------------------- */
        retailAndServiceCategory: 'Розничная торговля и услуги',
        onlineRetailEcommerce: 'Онлайн-розничная торговля и электронная коммерция',
        departmentStores: 'Департаменты',
        lifeServices: 'Жизненные услуги',
        retailServicesAndDelivery: 'Розничные услуги/Доставка',
        supermarkets: 'Супермаркеты',
        otherRetailAndService: 'Другие розничные услуги',
        /**----------------------- */
        apparelCategory: 'Одежда и аксессуары',
        footwear: 'Обувь',
        clothing: 'Одежда',
        watchesWatchRetail: 'Часы',
        jewelry: 'Ювелирные изделия',
        bags: 'Сумки',
        eyewearOpticalStores: 'Очки',
        otherClothingAndAccessories: 'Другие одежда и аксессуары',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Ремонт и отделка',
        homeFurnishing: 'Мебель',
        homeImprovement: 'Ремонт',
        otherHomeImprovementAndFurnishings: 'Другие ремонтные и отделочные услуги',
        /**----------------------- */
        financialAndInsuranceCategory: 'Финансы и страхование',
        bank: 'Банки',
        fintech: 'Финансовые технологии',
        investmentAndFinancialServices: 'Финансовые услуги',
        insurance: 'Страхование',
        otherFinancialAndInsurance: 'Другие финансовые и страховые услуги',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Развлечения и отдых',
        socialApp: 'Социальные приложения',
        toysAndDolls: 'Игрушки',
        concerts: 'Концерты',
        events: 'События',
        movies: 'Фильмы',
        themeParks: 'Тематические парки',
        gambling: 'Гambling',
        onlineGaming: 'Онлайн-игры',
        tvChannels: 'Телеканалы',
        otherEntertainmentAndLeisure: 'Другие развлечения и отдых',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Промышленность и сельское хозяйство',
        industrialSupplies: 'Промышленные материалы',
        agriculturalSupplies: 'Сельскохозяйственные материалы',
        otherIndustrialAndAgricultural: 'Другие промышленные и сельскохозяйственные материалы',
        /**----------------------- */
        petLifeCategory: 'Животные',
        petFood: 'Корм для животных',
        petSupplies: 'Сервисы для животных',
        otherPetLife: 'Другие услуги для животных',
        /**----------------------- */
        educationAndLearningCategory: 'Образование и обучение',
        onlineLearning: 'Онлайн обучение',
        schools: 'Школы',
        skillCourses: 'Курсы',
        tutoring: 'Репетиторство',
        universities: 'Университеты',
        otherEducationAndLearning: 'Другие образовательные услуги',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Сообщества и общественные услуги',
        charityCampaigns: 'Благотворительные кампании',
        ngoAds: 'Реклама НПО',
        otherCommunityAndPublicService: 'Другие сообщества и общественные услуги',
        /**----------------------- */
        otherCategory: 'Другие категории',
        governmentAdvertising: 'Государственная реклама',
        realEstateAdvertising: 'Недвижимость',
        otherAdvertising: 'Другие виды рекламы',
      },
      genderSelect: {
        male: 'Мужской',
        female: 'Женский',
        all: 'Все',
      },
      targetMarketSelect: {
        China: 'Китай',
        HongKongChina: 'Гонконг, Китай',
        MacauChina: 'Макао, Китай',
        TaiwanChina: 'Тайвань, Китай',
        Japan: 'Япония',
        Korea: 'Корея',
        Mongolia: 'Монголия',
        Singapore: 'Сингапур',
        Thailand: 'Таиланд',
        Vietnam: 'Вьетнам',
        Malaysia: 'Малайзия',
        Philippines: 'Филиппины',
        Indonesia: 'Индонезия',
        Cambodia: 'Камбоджа',
        Laos: 'Лаос',
        India: 'Индия',
        SaudiArabia: 'Саудовская Аравия',
        Turkey: 'Турция',
        Israel: 'Израиль',
        UnitedArabEmirates: 'Объединённые Арабские Эмираты',
        Qatar: 'Катар',
        Kuwait: 'Кувейт',
        UnitedKingdom: 'Великобритания',
        France: 'Франция',
        Germany: 'Германия',
        Netherlands: 'Нидерланды',
        Belgium: 'Бельгия',
        Austria: 'Австрия',
        Italy: 'Италия',
        Spain: 'Испания',
        Portugal: 'Португалия',
        Greece: 'Греция',
        Sweden: 'Швеция',
        Norway: 'Норвегия',
        Finland: 'Финляндия',
        Denmark: 'Дания',
        Estonia: 'Эстония',
        Latvia: 'Латвия',
        Russia: 'Россия',
        Poland: 'Польша',
        CzechRepublic: 'Чешская Республика',
        Hungary: 'Венгрия',
        Romania: 'Румыния',
        Bulgaria: 'Болгария',
        Slovakia: 'Словакия',
        Slovenia: 'Словения',
        Ukraine: 'Украина',
        UnitedStates: 'США',
        Canada: 'Канада',
        Mexico: 'Мексика',
        Brazil: 'Бразилия',
        LatinAmerica: 'Латинская Америка',
        Australia: 'Австралия',
        NewZealand: 'Новая Зеландия',
        Other: 'Другое',
      },
      languageSelect: {
        english: 'Английский',
        chinese: 'Китайский',
        japanese: 'Японский',
        korean: 'Корейский',
        french: 'Французский',
        traditionalChinese: 'Традиционный китайский',
      },
      placeholder: {
        projectName: 'Введите название проекта',
        category: 'Выберите категорию',
        brandName: 'Введите название бренда',
        adName: 'Введите название рекламы',
        norm: 'Выберите эталонное значение',
        taGender: 'Выберите пол',
        targetMarket: 'Выберите целевой рынок',
        taAge: 'Выберите возраст',
        lowerLimit: 'Нижний предел',
        upperLimit: 'Верхний предел',
        outputLanguage: 'Выберите язык вывода',
      },
      step: {
        step1: 'Ввод информации о проекте',
        step2: 'Подтверждение информации о заказе',
      },
      message: {
        success: 'Создание успешно',
        videoDurationOver60s: 'Длительность видео превышает {{max}} секунд',
        videoDurationLessThan10s: 'Длительность видео менее {{min}} секунд',
        videoDurationNeedOver10s: 'Длительность видео должна быть более 10 секунд',
        videoDurationNeedWithin5To10s: 'Длительность видео должна быть от 5 до 10 секунд',
        videoDurationNotMatchDurationCategory: 'Текущая длительность видео не соответствует этому типу проекта. Пожалуйста, загрузите видео заново и попробуйте снова.',
        videoUploadingCannotSwitchDurationCategory: 'Нельзя переключать тип креатива во время загрузки видео. Дождитесь завершения загрузки.',
        videoFormatOrDurationError: 'Не удалось определить формат или длительность видео. Проверьте видеофайл и повторите попытку.',
        videoSizeOver200M: 'Размер видео превышает 256 МБ',
        videoLandscape: 'Видео должно быть в формате горизонтального видео',
        videoPortrait: 'Видео должно быть в вертикальном формате',
        clickToUploadTestVideo: 'Нажмите, чтобы загрузить тестовое видео',
        uploadFailed: 'Загрузка не удалась, пожалуйста, попробуйте снова',
        uploadDesc1: 'Поддерживаются видеофайлы в форматах MP4, MOV,',
        uploadDescPortrait: 'Поддерживаются вертикальные видеофайлы в форматах MP4, MOV',
        uploadDesc2: 'Другие форматы, ограничение по размеру файла 256 МБ',
        formNotCompleted: 'Пожалуйста, заполните всю информацию',
        uploadAdVideo: 'Пожалуйста, загрузите рекламное видео',
        inputInvalid: 'Недопустимый ввод',
        insufficientTestPoints:
          'Недостаточно тестовых баллов, пожалуйста, пополните счет и попробуйте снова.',
        reviewProjectInfo:
          'Пожалуйста, внимательно проверьте информацию о вашем проекте. После подтверждения заказа изменения не будут возможны.',
        waitingDesc:
          'Максимум 3 проекта могут анализироваться одновременно. Этот проект добавлен в очередь ожидания и анализ начнется автоматически позже.',
        ageRangeInvalid: 'Диапазон возраста поддерживается только 20-55',
        normDesc:
          'Неограниченные преимущества авторского права, компания может установить собственное нормативное значение',
      },
    },
    projectDetailPage: {
      testResults: 'Результаты тестирования',
      share: 'Поделиться',
      shareFailed: 'Не удалось поделиться',
      shareModal: {
        title: 'Поделиться',
        desc: 'Скопируйте текст ниже и поделитесь им в соцсетях.',
        saveImage: 'Сохранить изображение',
        copyText: 'Скопировать текст',
        copySuccess: 'Скопировано',
        copyFailed: 'Не удалось скопировать',
        textTemplate:
          'Вау! Мой AI-креатив превзошёл {{score}}% похожих работ на AdEff! Данные говорят сами за себя! Тестирование AI-креативов AdEff сейчас бесплатно. Проверьте свой результат на {{hostname}}. Получите 5 бесплатных тестов и желаем вам отличных оценок!',
      },
      sharePoster: {
        createdByYou: 'Создано вами',
        scoreTemplate: 'Превзошло <score>{{score}}</score> AIGC-креативов',
        statsAt: 'Статистика на ',
        certification: 'Сертификат креативности',
        footerText: 'Ждём ваших новых идей и ещё больше качественных работ!',
      },
      basicInformation: 'Основная информация',
      waiting: 'Ожидание',
      ongoing: 'В процессе',
      failed: 'Неудача',
      tryAgain: 'Попробуйте снова',
      videoAnalysisFailed: 'Не удалось проанализировать видео',
      message: { projectNotFound: 'Проект не найден' },
      primaryAnalysis: 'Ключевые показатели',
      detailAnalysis: 'Анализ по моментам',
      heatmapAnalysis: 'Тепловая карта',
      analysisStepDesc: 'AI завершил все задачи анализа, подробный анализ ниже',
      analysisWaitingDesc:
        'Максимум 3 проекта могут анализироваться одновременно. Этот проект добавлен в очередь ожидания и анализ начнется автоматически позже',
      aiTip: 'Содержание отчета генерируется ИИ и предназначено только для справки',
      subAnalysisDescription: {
        adVideoScore: 'Индекс эффективности рекламы',
        adVideoScoreDesc:
          'Индекс эффективности рекламы является комплексным показателем эффективности рекламы, способным предсказывать краткосрочные и долгосрочные эффекты рекламы.',
        norm: 'Норматив',
        normDesc:
          'Нормативные значения для отрасли или исторических данных, используемые для горизонтального сравнения рекламной эффективности.',
        attentionIndex: 'Индекс внимания',
        attentionIndexDesc:
          'Степень концентрации визуального внимания аудитории, отражающая способность рекламного изображения привлекать внимание.',
        emotionIndex: 'Индекс эмоций',
        emotionIndexDesc:
          'Степень, в которой положительные эмоции аудитории были вызваны, отражающая мгновенные эмоциональные колебания, вызванные рекламой.',
        cognitionIndex: 'Индекс познания',
        cognitionIndexDesc:
          'Отражает степень когнитивной обработки аудитории, то есть в какой степени они обдумали содержание рекламы.',
        theGolden3Seconds: 'Золотые 3 секунды',
        theGolden3SecondsDesc:
          'Первые 3 секунды рекламы являются ключевым моментом, определяющим успех рекламы.',
        informationTransmission: 'Информационный момент',
        informationTransmissionDesc:
          'Оценивает способность рекламного сообщения захватывать внимание целевой аудитории и вызывать интерес.',
        brandRelevance: 'Брендовый момент',
        brandRelevanceDesc:
          'Оценивает способность брендового момента захватывать внимание целевой аудитории и вызывать интерес.',
        interestStimulation: 'Момент интереса',
        interestStimulationDesc:
          'Ключевой момент, вызывающий эмоциональный отклик и активное познание аудитории.',
        theEnding3Seconds: 'Заключительные 3 секунды',
        theEnding3SecondsDesc:
          'На основе закона пиков и концов, последние 3 секунды рекламы являются ключевым моментом для закрепления внимания зрителей и усиления передачи информации.',
      },
      infoDrawer: {
        basicInformation: 'Основная информация',
        advertisingInformation: 'Информация о рекламе',
        projectName: 'Название проекта',
        brandName: 'Название бренда',
        category: 'Отрасль',
        norm: 'Норматив целевого рынка',
        normLabel: 'Норматив',
        brandNorm: 'Норматив бренда',
        adName: 'Название рекламы',
        taGender: 'Пол целевой аудитории',
        targetMarket: 'Целевой рынок',
        taAge: 'Возраст целевой аудитории',
        ageRange: '{{start}} до {{end}} лет',
        modify: 'Изменить',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
      },
      videoView: {
        eyeMovementRatio: 'Индекс внимания',
        cognitiveEngagement: 'Индекс познания',
        emotionRecognition: 'Индекс эмоций',
        subjectiveResponseCurve: 'Кривая субъективного отклика',
        realtimeData: 'Реальные данные',
        panoramicData: 'Панорамные данные',
        indexAnalysis: 'Анализ показателей',
        advantage: 'Преимущества',
        disadvantage: 'Недостатки',
        suggestions: 'Рекомендации',
        adVideoScore: 'Индекс эффективности рекламы',
        norm: 'Норматив',
        analysisStepTitle1: 'Декодирование контента',
        analysisStepTitle2: 'Прогнозирование отзывов',
        analysisStepTitle3: 'Интеграция данных',
        analysisStepTitle4: 'Выводы и рекомендации',
        analysisStepDesc1:
          'Начинаем многомодальное декодирование рекламного контента, декодирование визуального, аудио, текстового и структурного...',
        analysisStepDesc2:
          'Начинаем прогнозировать субъективный отклик аудитории, основываясь на содержании рекламы, прогнозируем данные о глазных движениях и ЭЭГ...',
        analysisStepDesc3:
          'Начинаем интеграцию объективного содержания рекламы и субъективных данных о реакции аудитории...',
        analysisStepDesc4:
          'Начинаем генерировать оценочные выводы и рекомендации на основе модели вывода...',
        keyResult: 'Ключевой результат',
        videoChart: {
          videoFailed: 'Не удалось воспроизвести видео',
          videoFailedAction:
            'Пожалуйста, обновите страницу и попробуйте снова. Если проблема продолжается после нескольких обновлений, пожалуйста, свяжитесь с нами для получения помощи.',
        },
      },
      storyboardView: {
        summary: 'Резюме',
        advantages: 'Преимущества',
        disadvantages: 'Недостатки',
        suggestions: 'Рекомендации',
        keyResult: 'Ключевой результат',
        norm: 'Норматив',
        theGolden3Seconds: 'Золотые 3 секунды',
        informationTransmission: 'Информационный момент',
        brandRelevance: 'Брендовый момент',
        interestStimulation: 'Момент интереса',
        theEnding3Seconds: 'Заключительные 3 секунды',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Электронная почта',
      username: 'Имя пользователя',
      password: 'Пароль',
      setPasswordToEnableEmailLogin: 'Установите пароль для включения входа по электронной почте',
      uid: 'UID',
      contactAndReceiveNotifications: 'Связаться и получать уведомления',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Получайте электронные письма с последними обновлениями AdEff на этот адрес электронной почты.',
      myWorkspace: 'Мое рабочее пространство',
      newRequest: 'Новый запрос',
      invitationCode: 'Реферальный код',
      userName: 'Имя пользователя',
      invitationCodeDesc:
        'У каждой команды есть уникальный пригласительный код, который используется новыми пользователями для запроса присоединения к команде во время регистрации',
      table: {
        userName: 'Имя пользователя',
        email: 'Электронная почта',
        operation: 'Операция',
        admin: 'Администратор',
        remove: 'Удалить',
        deny: 'Отклонить',
        approve: 'Одобрить',
      },
      message: {
        yourTeamIsFull:
          'Ваша команда полна. Вы можете связаться с нами для получения дополнительных участников или удалить других участников.',
        invitationLinkSent: 'Пригласительная ссылка отправлена на этот адрес электронной почты!',
        removeReminder: 'Напоминание об удалении',
        remove: 'Удалить',
        removeMember:
          'После удаления участника, созданный им контент останется. Вы хотите продолжить удаление участника?',
        removeMemberSuccess: 'Участник успешно удален!',
        ok: 'Хорошо',
        contactUs: 'Связаться с нами',
        applicationProcessedSuccessfully: 'Заявка успешно обработана!',
        notificationSettingsTurnedOn: 'Настройки уведомлений включены',
        notificationSettingsTurnedOff: 'Настройки уведомлений отключены',
        setPassword: 'Установить пароль',
        passwordConfirm: 'Подтвердить',
        passwordCancel: 'Отмена',
        oldPassword: 'Старый пароль',
        newPassword: 'Новый пароль',
        pleaseEnterTheOldPassword: 'Пожалуйста, введите старый пароль',
        pleaseEnterTheNewPassword: 'Пожалуйста, введите новый пароль',
        incorrectEntryOfOriginalPassword: 'Ошибка ввода старого пароля',
        passwordUpdatedSuccessfully: 'Пароль успешно обновлен',
        changeUsername: 'Изменить имя пользователя',
        confirm: 'Подтвердить',
        cancel: 'Отмена',
        username: 'Имя пользователя',
        pleaseEnterTheNewUsername: 'Пожалуйста, введите новое имя пользователя',
        userNameUpdatedSuccessfully: 'Имя пользователя успешно обновлено',
        addMemberToWorkspace: 'Добавить нового участника в рабочее пространство',
        notAdminOperate: 'Не администратор, не может выполнять операции',
        emailAddress: 'Электронный адрес',
        send: 'Отправить',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Мы отправим на этот адрес приглашение по электронной почте для подтверждения.',
        workspaceMemberShip: 'Членство в рабочем пространстве',
        forMoreMembership: 'Больше членства',
        reachedTheCeiling: 'Достигнут предел.',
        incorrectMailboxFormat: 'Неверный формат электронной почты',
        member: 'Участник',
        changeCorpNameTitle: 'Изменить название компании',
        changeCorpNameLabel: 'Название компании',
        pleaseEnterTheCorpName: 'Пожалуйста, введите название компании',
        changeCorpNameSuccess: 'Название компании успешно изменено',
        changeCorpNameFailed: 'Изменение названия компании не удалось',
        noPermission: 'У вас нет разрешения на изменение названия компании',
      },
    },
    subscriptionPage: {
      currentPlan: 'Текущий план',
      getInvoice: 'Получить ваш счет',
      remainingTimes: 'Осталось раз',
      purchaseMore: 'Купить больше',
      contactUs: 'Связаться с нами',
      teamPlan: 'Услуги команды экспертов',
      unlimited: 'Безлимит',
      dueDate: 'Дата окончания',
      table: {
        usageRecords: 'Записи использования',
        date: 'Дата',
        projectName: 'Название проекта',
        projectType: 'Тип проекта',
        usageCount: 'раз',
        userName: 'Имя пользователя',
        noRelevantContent: 'Не найдено соответствующего контента',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Проект обычного креатива',
      regularCreative: 'Обычный креатив',
      splashCreativeProject: 'Проект splash-креатива',
      splashCreative: 'Splash-креатив',
      projects: 'Проекты',
      localNorm: 'Локальный бенчмарк',
      projectPassRate: 'Доля успешных проектов',
      passRate: 'Доля успешных',
    },
    dataDetailPage: {
      baseData: 'Базовые данные',
      totalProjects: 'Общее количество проектов',
      totalProjectsDesc: 'Общее количество проектов, участвующих в оценке эффективности рекламы.',
      // averageEffectivenessIndex: 'Средний индекс эффективности',
      // averageEffectivenessIndexDesc:
      // 'Средний индекс эффективности рекламы из всех допустимых проектов.',
      localNormProjects: 'Локальные нормативные проекты',
      brandNormProjects: 'Нормативные проекты бренда',
      normProject: 'Нормативный проект целевого рынка',
      brandNormProject: 'Нормативный проект бренда',
      localNorm: 'Локальный норматив',
      localNormDesc:
        'Среднее значение индекса эффективности рекламы для действительных рекламных проектов, ориентированных на вашу страну.',
      norm: 'Норматив',
      brandNorm: 'Норматив бренда',
      brandNormDesc:
        'Среднее значение индекса эффективности рекламы для действительных рекламных проектов, ориентированных на ваш собственный бренд.',
      localProjectPassRate: 'Процент прохождения локальных проектов',
      projectPassRate: 'Процент прохождения проектов',
      brandProjectPassRate: 'Процент прохождения проектов бренда',
      projectPassRateDesc: 'Процент проектов, индекс эффективности которых превышает норматив.',
      advertisingEffectivenessIndexDistribution: 'Распределение индекса эффективности рекламы',
      advertisingEffectivenessIndexDistributionDesc:
        'Распределение индекса эффективности рекламы по всем допустимым проектам.',
      item: 'элемент',
    },
    dataComparisonPage: {
      createCompare: 'Новое сравнение',
      createCompareDesc: 'Выберите несколько проектов для сравнения, максимум 10 проектов.',
      startCompare: 'Начать сравнение',
      compareReport: 'Отчеты сравнения',
      searchPlaceholder: 'Поиск по названию отчета сравнения',
      emptyText: 'Отчетов сравнения пока нет. Сначала выберите проекты для сравнения.',
      searchEmptyText: 'Отчеты сравнения не найдены.',
      deleteTitle: 'Удалить отчет сравнения',
      deleteConfirm: 'Вы уверены, что хотите удалить этот отчет сравнения? Это действие нельзя отменить.',
      projectCount: '{{count}} проектов',
    },
    dataComparisonStartPage: {
      back: 'Назад',
      basicInfo: 'Основная информация',
      reportName: 'Название отчета:',
      reportNamePlaceholder: 'Введите название отчета сравнения',
      norm: 'Бенчмарк:',
      normPlaceholder: 'Выберите бенчмарк',
      normTip: 'Выберите бенчмарк для сравнения проектов',
      selectProject: 'Выбрать проекты',
      searchPlaceholder: 'Поиск по проекту/рекламе/бренду',
      selectedCountPrefix: ' Выбрано ',
      selectedCountSuffix: ' проектов, максимум {{max}} проектов',
      startCompare: 'Начать сравнение',
      save: 'Сохранить',
      cancel: 'Отмена',
      maxSelectedWarning: 'Можно выбрать до 10 проектов',
      reportNameRequired: 'Введите название отчета сравнения',
      normRequired: 'Выберите бенчмарк',
      projectRequired: 'Выберите проекты',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Название отчета сравнения',
      reportNotFound: 'Отчет не найден',
      back: 'Назад',
      modify: 'Редактировать',
      deletedProjectTip: 'Следующие проекты: {{names}} были удалены. После подтверждения сравнительный отчет будет обновлен, а удаленные проекты будут исключены.',
      confirmDeletedProjects: 'Подтвердить',
      metricScore: 'Оценка индикатора',
      tabDimension: 'Пять измерений',
      tabMoment: 'Ключевой момент',
      tabAttitude: 'Отношение потребителя',
      adeffScore: 'Оценка AdEff',
      brandName: 'Название бренда',
      projectName: 'Название проекта',
      industry: 'Отрасль',
      targetMarket: 'Целевой рынок',
      gender: 'Пол TA',
      age: 'Возраст TA',
      adProject: 'Рекламный проект',
      normLabel: 'Бенчмарк',
      mixedCreativeBenchmarkTip: 'При одновременном сравнении обычных и splash-креативов бенчмарк недоступен.',
      emptyProject: 'Выберите проекты, чтобы посмотреть данные сравнения',
      viewProjectDetail: 'Посмотреть детали проекта',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Сила внимания',
        infectivity: 'Эмоциональная сила',
        delivery: 'Сила сообщения',
        brand: 'Сила бренда',
        persuasion: 'Сила убеждения',
        gazeRecognition: 'Распознавание взгляда',
        emotionRecognition: 'Распознавание эмоций',
        engagementRecognition: 'Распознавание вовлеченности',
        goldenSeconds: 'Золотые 3 секунды',
        brandMoment: 'Брендовый момент',
        productMoment: 'Момент интереса',
        messageMoment: 'Информационный момент',
        endingSeconds: 'Заключительные 3 секунды',
        likeability: 'Симпатия',
        newInformation: 'Новая информация',
        messageRelevance: 'Релевантность сообщения',
        comprehension: 'Понимание',
        credibility: 'Доверие',
        brandLinkage: 'Связь с брендом',
        uniqueness: 'Уникальность',
        learnMoreIntent: 'Готовность узнать больше',
        purchaseIntent: 'Намерение покупки',
        recommendIntent: 'Готовность делиться',
        brandLikeabilityLift: 'Рост симпатии к бренду',
        purchaseIntentionLift: 'Рост намерения покупки',
        attentionIndex: 'Индекс внимания',
        emotionIndex: 'Индекс эмоций',
        cognitionIndex: 'Индекс познания',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Ваш проект оценки креатива TVC завершен.',
        title: {
          text1: 'Тестирование рекламного креатива',
          text2: 'Отчет о тесте',
        },
        flowAnalysis: {
          desc1: 'AdEff деконструирует ваше видеорекламное объявление',
          desc2: 'Деконструкция видео завершена',
          desc3: 'Анализируется визуальное внимание потребителей',
          desc4: 'Анализируется визуальный фокус на основе профилей потребителей',
          desc5: 'Создается тепловая карта внимания',
          desc6: 'Динамическая тепловая карта создана',
          desc7: 'Измеряются когнитивно-нейронные реакции',
          desc8: 'Отслеживаются взгляд, эмоции и вовлеченность каждую секунду',
          desc9: 'Создается кривая нейронной реакции',
          desc10: 'Кривая нейронной реакции создана',
          desc11: 'Анализируется эффективность в ключевые моменты',
          desc12: 'Измеряются когнитивно-нейронные реакции во время: золотых 3 секунд, момента сообщения, момента бренда, пика интереса и последних 3 секунд',
          desc13: 'Сводятся метрики ключевых моментов',
          desc14: 'Анализ ключевых моментов завершен',
          desc15: 'Анализируются потребительские установки',
          desc16: 'Анализируются установки к бренду, продукту и контенту',
          desc17: 'Сводятся метрики установок',
          desc18: 'Метрики установок завершены',
          desc19: 'Создаются оценки пяти факторов воздействия',
          desc20: 'Оценки пяти факторов воздействия готовы',
          desc21: 'Анализ завершен! Ваш отчет об эффективности рекламы готов',
          terminology: {
            thumbExpand: 'Развернуть миниатюры',
            thumbCollapse: 'Свернуть миниатюры',
            gazeRecognition: 'Распознавание взгляда',
            gazeRecognitionDesc: 'Измеряет концентрацию визуального внимания и показывает, насколько эффективно элементы рекламы удерживают фокус зрителя.',
            emotionRecognition: 'Распознавание эмоций',
            emotionRecognitionDesc: 'Количественно оценивает положительные эмоции и мгновенные эмоциональные реакции, вызванные рекламой.',
            engagementRecognition: 'Распознавание вовлеченности',
            engagementRecognitionDesc: 'Измеряет погружение и вовлеченность, отражая мысленное участие в рекламном контенте.',
            theGolden3Seconds: 'Эффективность золотых 3 секунд',
            theGolden3SecondsDesc: 'Оценивает эффективность содержания рекламы в первые 3 секунды.',
            keyMessage: 'Эффективность ключевого сообщения',
            keyMessageDesc: 'Измеряет способность информационных моментов рекламы привлекать внимание и стимулировать интерес.',
            brand: 'Эффективность бренда',
            brandDesc: 'Оценивает способность бренда привлекать внимание и эффективность вовлечения.',
            interest: 'Пик интереса',
            interestDesc: 'Выявляет пики контента, вызывающие эмоциональный отклик и высокую вовлеченность.',
            ending3Seconds: 'Эффективность последних 3 секунд',
            ending3SecondsDesc: 'Оценивает эффективность содержания рекламы в последние 3 секунды.',
            score: 'Оценка',
            benchmark: 'Бенчмарк',
            metrics: 'Метрики',
            attitudePart: {
              attitudeMetrics: 'Метрики отношения',
              liking: 'Симпатия',
              likingDesc: 'Измеряет субъективное отношение аудитории и общий уровень симпатии к рекламе.',
              newInformation: 'Новая информация',
              newInformationDesc: 'Измеряет, считает ли аудитория, что получила из рекламы ранее неизвестную ценную информацию о бренде или продукте.',
              messageRelevance: 'Релевантность сообщения',
              messageRelevanceDesc: 'Измеряет, насколько аудитория воспринимает информацию в рекламе как напрямую связанную с собой.',
              comprehension: 'Понимание',
              comprehensionDesc: 'Измеряет, было ли ключевое сообщение рекламы понято ясно, точно и без усилий.',
              credibility: 'Доверие',
              credibilityDesc: 'Измеряет, насколько аудитория считает переданную информацию правдивой, надежной и заслуживающей доверия.',
              brandLinkage: 'Связь с брендом',
              brandLinkageDesc: 'Измеряет способность аудитории правильно и прочно связать рекламу с конкретным брендом.',
              uniqueness: 'Уникальность',
              uniquenessDesc: 'Измеряет, формирует ли реклама четкое восприятие отличительной и ценной уникальности бренда по сравнению с конкурентами.',
              willing: 'Готовность узнать больше',
              willingDesc: 'Измеряет субъективную вероятность того, что аудитория после просмотра активно захочет узнать больше о бренде или продукте.',
              purchase: 'Намерение покупки',
              purchaseDesc: 'Измеряет субъективную вероятность того, что аудитория в будущем рассмотрит выбор или покупку продукта бренда.',
              share: 'Готовность делиться',
              shareDesc: 'Измеряет субъективную вероятность того, что аудитория активно поделится рекламой или информацией о бренде с другими.',
              brandLikeLift: 'Рост симпатии к бренду',
              brandLikeLiftDesc: 'Измеряет направление и степень изменения общей симпатии к бренду или продукту после контакта с рекламой.',
              purchaseIntentLift: 'Рост намерения покупки',
              purchaseIntentLiftDesc: 'Измеряет направление и степень изменения готовности рассмотреть покупку продукта бренда после контакта с рекламой.',
            },
            dimensionPart: {
              forceDrives: 'Факторы воздействия',
              attension: 'Внимание',
              emotionalImpact: 'Эмоциональное воздействие',
              messageClarity: 'Ясность сообщения',
              brandPower: 'Сила бренда',
              persuasion: 'Убедительность',
              attentionForce: 'Сила внимания',
              attentionForceDesc: 'Измеряет способность рекламы привлекать и удерживать визуальное и слуховое внимание аудитории.',
              emotionalForce: 'Эмоциональная сила',
              emotionalForceDesc: 'Измеряет интенсивность мгновенного, инстинктивного эмоционального отклика и колебаний, вызванных содержанием рекламы.',
              messageForce: 'Сила сообщения',
              messageForceDesc: 'Измеряет эффективность того, насколько ключевое сообщение рекламы ясно распознается, точно понимается и глубоко запоминается целевой аудиторией.',
              brandForce: 'Сила бренда',
              brandForceDesc: 'Измеряет эффективность рекламы в укреплении идентичности бренда, повышении симпатии и создании прочной связи с брендом.',
              persuasiveForce: 'Сила убеждения',
              persuasiveForceDesc: 'Измеряет итоговую способность рекламы менять восприятие и стимулировать поведенческие намерения.',
            },
            result: {
              results: 'Результаты',
              pass: 'Прошел',
              notPass: 'Не прошел',
              adeffScore: 'Оценка AdEff',
              adeffScoreDesc: 'Оценка AdEff предназначена для измерения общей эффективности рекламы.',
              benchmarkDesc: 'Средняя оценка AdEff всех загруженных реклам в стране или регионе объявления используется для сравнения его эффективности.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Ожидание...',
            description: 'Создаем для вас отчет о тесте...',
          },
          generating: 'Создается...',
          freeTrialLockText1:
            'В пробном режиме предварительный просмотр и скачивание полного отчета недоступны.',
          freeTrialLockText2: 'Оформите подписку, чтобы разблокировать доступ.',
        },
      },
    },
  },
  professor: {
    account: 'Аккаунт',
    password: 'Пароль',
    login: 'Вход',
    expertReviews: 'Экспертные обзоры',
    adVideoScore: 'Индекс эффективности рекламы',
    subjectiveResponseCurve: 'Кривая субъективного отклика',
    indexAnalysis: 'Анализ показателей',
    keyResult: 'Ключевой результат',
    theGolden3Seconds: 'Золотые 3 секунды',
    informationTransmission: 'Информационный момент',
    brandRelevance: 'Брендовый момент',
    interestStimulation: 'Момент интереса',
    theEnding3Seconds: 'Заключительные 3 секунды',
    heatMap: 'Тепловая карта',
    suggestion: 'Рекомендации',
    suggestion1: 'Рекомендация',
    submit: 'Отправить',
    next: 'Следующий',
    summary: 'Сводка',
    advantages: 'Преимущества',
    disadvantages: 'Недостатки',
    option1: 'Ожидаемый',
    option2: 'Неожиданный',
    resultJudgment: 'Оценка',
    placeholder: 'Введите предложение',
    waitRateCount: 'Количество рекламных видео, ожидающих оценки',
    unfinishedTitle: 'Напоминание',
    unfinishedRate: 'В текущем проекте есть непроверенные элементы, вы уверены, что хотите выйти?',
    unfinishedConfirm: 'Продолжить оценку',
    unfinishedCancel: 'Выйти',
    message: {
      submitSuccess: 'Спасибо за ваш отзыв',
      submitSuccess1: 'Вы уже оценили этот проект, спасибо за ваш отзыв',
      loginSuccess: 'Вход выполнен успешно',
      rateUnfinished:
        'Вы еще не оценили текущее содержание, пожалуйста, заполните его перед переходом к следующему вопросу',
      rateLocation: 'Вы автоматически перенаправлены на непроверенный элемент',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Запрос на пробную версию',
      title1: 'Бесплатная пробная версия',
      trial: 'Пробная версия',
      hiddenBoxText1: 'Обнаружено несколько преимуществ, недостатков и предложений',
      hiddenBoxText2: 'Подпишитесь, чтобы получить полный отчет',
      hiddenBoxBtn: 'Подписаться',
      applyBox: {
        name: 'Ваше имя',
        tel: 'Номер телефона',
        department: 'Отдел',
        role: 'Роль',
        country: 'Страна',
        city: 'Город',
        pleaseEnter: 'Пожалуйста, введите',
        pleaseSelect: 'Пожалуйста, выберите',
        pleaseEnterTheName: 'Пожалуйста, введите ваше имя',
        pleaseEnterTheTel: 'Пожалуйста, введите ваш номер телефона',
        pleaseEnterValidTel: 'Пожалуйста, введите ваш номер телефона',
        pleaseEnterValidEmail: 'Пожалуйста, введите корректный адрес электронной почты',
        pleaseSelectTheDepartment: 'Пожалуйста, выберите ваш отдел',
        pleaseSelectTheRole: 'Пожалуйста, выберите вашу роль',
        pleaseSelectTheCountry: 'Пожалуйста, выберите вашу страну',
        pleaseEnterTheCity: 'Пожалуйста, введите ваш город',
        textIsRequired: 'Это поле обязательно для заполнения',
        submit: 'Отправить',
        tip: 'Для каждой компании доступен только один бесплатный тестовый проект',
      },
      gotTrial: 'Вы получили пробную версию!',
      goPc: 'Пожалуйста, перейдите к веб-версии PC, чтобы создать свой проект.',
      back: 'Вернуться',
      country: {
        China: 'Китай',
        Japan: 'Япония',
        Korea: 'Корея',
        Indonesia: 'Индонезия',
        Thailand: 'Таиланд',
        Singapore: 'Сингапур',
        Malaysia: 'Малайзия',
        Vietnam: 'Вьетнам',
        Germany: 'Германия',
        Britain: 'Великобритания',
        France: 'Франция',
        Italy: 'Италия',
        Russia: 'Россия',
        Spain: 'Испания',
        Turkey: 'Турция',
        America: 'США',
        Canada: 'Канада',
        Brazil: 'Бразилия',
        Other: 'Другое',
      },
      department: {
        Brand: 'Бренд',
        Market: 'Маркетинг',
        Marketing: 'Маркетинг',
        IT: 'IT',
        Procurement: 'Покупка',
        Other: 'Другое',
      },
      role: {
        President: 'Президент/Вице-президент/Генеральный директор',
        CMO: 'CMO или другой C-level менеджмент',
        Director: 'Директор отдела',
        Manager: 'Менеджер отдела',
        Other: 'Другое',
      },
      message: {
        submitSuccess: 'Спасибо за ваш отзыв',
        submitFailed: 'Спасибо за ваш отзыв',
      },
    },
    downloadPptRechargeModal: {
      title: 'Отчет не может быть загружен',
      desc1: 'В пробной версии невозможно скачать отчет',
      desc2: 'Подпишитесь, чтобы получить полный отчет',
      btn: 'Подписаться',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Реферальный код',
      invitationCodeDesc1:
        'Реферальный код не может быть изменен, пожалуйста, свяжитесь с нами, если вы хотите изменить его',
      invitationCodeDesc2:
        'Если вы используете это через реферальную программу агента, пожалуйста, введите реферальный код',
      invitationCodePlaceholder: 'Введите реферальный код',
      invitationCodeError: 'Недействительный реферальный код',
      invitationCodeSuccess: 'Реферальный код успешно изменен',
      ok: 'Хорошо',
      cancel: 'Отмена',
    },
    aigcPromotionModal: {
      title: 'Преимущества для создателей AIGC',
      subTitle: 'Зарегистрируйтесь сейчас и получите <tmp>5</tmp> возможностей оценки AI-видео',
      desc1: 'Присоединяйтесь к событию AdEff AI Creative Testing, чтобы оценить свои креативы.',
      desc2: 'Зарегистрируйтесь сейчас и сразу получите 5 бесплатных тестов.',
      registerBtn: 'Зарегистрироваться и получить тесты',
      tip: 'Только для новых пользователей, зарегистрированных через вход кампании для создателей AIGC',
      floatTitle: 'Бесплатное тестирование',
    },
  },
}

export default TRANSLATION
